import styled from "styled-components";

export const StyledHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space.sm};
`;

export const StyledTableWrapper = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.gray400}`};
  padding-bottom: ${({ theme }) => theme.space.md};
`;

export const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
`;
